import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          "& .common-box" :{
              background: "#fff",
              border: "1px solid #c0c1d258",
              borderRadius: "10px",
              boxShadow: "0 30px 50px #131b290a",
              margin: "20px 0",
              padding: "15px",
          },
        },
      },
    },
    MuiTypography:{
      styleOverrides: {
        root: {
          fontSize:"14px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&.MuiButton-contained": {
            background: "rgb(35, 136, 249)",
            color: "#fff",
            border: "1px solid rgb(35, 136, 249)",
            fontWeight:"600",
            borderRadius:"12px",
            padding:"8px 25px",
            "&:hover": {
              background: "rgb(35, 136, 249)",
              opcity:"0.8"
            },
          },
          "&.Mui-disabled":{
            color: "rgba(0, 0, 0, 0.26)",
            boxShadow: "none",
            backgroundColor: "rgba(0, 0, 0, 0.12)",
            borderColor: "rgba(0, 0, 0, 0.12)",
          },
        },
      },
    },
    MuiFormControl:{
      styleOverrides: {
        root: {
          "& .MuiInputBase-formControl":{
            "&.MuiNativeSelect-root":{
              "&:before, &:after":{
                display:"none",
              },
              "& .MuiNativeSelect-select" :{
                border:"1px solid rgba(0, 0, 0, 0.23)",
                padding:"9px 32px 9px 10px",
                textAlign:"center",
                minWidth:"30px",
              },
            },
            "& input":{
              padding: "11px 10px",
              background: "rgb(255, 255, 255)",
              height: "auto",
              fontSize: "16px",
              borderRadius: "5px",
              border: "0",
            },
          },
        },
      },
    },
    MuiSelect:{
      styleOverrides: {
        root: {
          minWidth: "200px",
          maxWidth: "200px",
          "& .MuiSelect-select":{
            padding: "10px 20px 10px 10px"
          },
        },
      },
    },
  },
});

export default theme;
